<template>
  <div>
    <!-- <Header :logoImg="indexinfo.system_logo" style="margin-top: 20px"></Header> -->
    <div class="head">
      <img @click="back" src="@/assets/images/back.png" class="arrow_img" />
      <span>{{ $t('lang1') }}</span>
    </div>
    <div class="home_page">
      <div class="pd">
        <div class="banner">
          <van-swipe :autoplay="3000" class="my-swipe" ref="swipeRef">
            <van-swipe-item class="swipe-item" v-for="(item, index) in indexinfo.banner_list" :key="index" @click="navigatorToPage('GoodsDetail', item.id)">
              <van-image style="width: 100%; height: 100%" radius="12" :src="item.img_url" />
            </van-swipe-item>
          </van-swipe>
        </div>
      </div>
      <div class="pd goods_box" v-for="(item, index) in goodsInfo" :key="index">
        <div class="title">
          <div class="flex">
            <span>{{ item.title }}</span>
          </div>
          <div class="" v-show="typeList.indexOf(item.type_id) != -1" @click="handleExpand(item.type_id, index)">
            <span class="all">{{ $t('lang24') }}</span>
            <van-icon name="arrow-up" color="#29b286" size="14px" />
          </div>
          <div class="" v-show="typeList.indexOf(item.type_id) == -1" @click="handleExpand(item.type_id, index)">
            <span class="all all1">{{ $t('lang25') }}</span>
            <van-icon name="arrow-down" color="#999" size="14px" />
          </div>
        </div>
        <div v-if="item.product.length > 0">
          <div class="goods_list" v-for="(item1, index1) in item.product" :key="index1" @click="navigatorToPage('GoodsDetail', item1.pro.id, item1.pro.product_id)">
            <van-image class="goods_list_img" radius="10" :src="item1.img_url" />
            <div class="right">
              <span class="ellipsis">{{ item1.name }}</span>
              <div class="cen">
                <span class="money flex">
                  {{ item1.pro.price }}
                  <svg width="12" height="22" viewBox="35 -2 50 96" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M70,35
           C56,28 38,40 40,54
           C40,64 50,74 70,66"
                      fill="none"
                      stroke="red"
                      stroke-width="6"
                      stroke-linecap="round"
                    />
                    <line x1="52" y1="29" x2="52" y2="73" stroke="red" stroke-width="5.2" stroke-linecap="round" />
                    <line x1="63" y1="29" x2="63" y2="73" stroke="red" stroke-width="5.2" stroke-linecap="round" />
                  </svg>
                </span>
                <div class="yel" v-if="item1.pro.status == 1">
                  <van-count-down
                    class="count"
                    :time="item1.pro.end_time * 1000 - new Date().getTime()"
                    :format="`${$t('lang8')} DD ${$t('lang9')} HH ${$t('lang10')} mm ${$t('lang11')} ss ${$t('lang12')}`"
                  />
                </div>
                <div class="yel" style="background-color: #f1f1f1" v-else-if="item1.pro.status == 0">
                  <span class="count" style="color: #aaa">{{ $t('lang72') }}</span>
                </div>
              </div>
              <div class="flex jsb flex_end">
                <div>
                  <span class="time_text flex">
                    {{ $t('lang6') }} {{ item1.pro.cost_price }}
                    <svg width="8" height="15" viewBox="35 0 50 96" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M70,35
           C56,28 38,40 40,54
           C40,64 50,74 70,66"
                        fill="none"
                        stroke="#7f7f7f"
                        stroke-width="6"
                        stroke-linecap="round"
                      />
                      <line x1="52" y1="29" x2="52" y2="73" stroke="#7f7f7f" stroke-width="5.2" stroke-linecap="round" />
                      <line x1="63" y1="29" x2="63" y2="73" stroke="#7f7f7f" stroke-width="5.2" stroke-linecap="round" />
                    </svg>
                  </span>
                  <div class="progress">
                    <van-progress :percentage="(item1.pro.num / item1.pro.stock) * 100 || 0" class="pro" color="#29b286" track-color="#9DDAC6" stroke-width="10" :show-pivot="false"> </van-progress>
                    <span class="p_text">{{ $t('lang26') }}{{ (Math.floor((item1.pro.num / item1.pro.stock) * 100) * 100) / 100 || 0 }}%</span>
                  </div>
                </div>
                <div class="buy">
                  <van-button class="buy_btn" type="primary">{{ $t('lang27') }}</van-button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="nomore" v-else>
          <span>{{ $t('lang60') }}</span>
        </div>
      </div>
      <!-- <div class="pd goods_box">
        <div class="title">
          <div class="flex">
            <span>{{ $t('lang29') }}</span>
          </div>
          <div class="" v-show="isExpand" @click="handleExpand">
            <span class="all">{{ $t('lang24') }}</span>
            <van-icon name="arrow-up" color="#29b286" size="14px" />
          </div>
          <div class="" v-show="!isExpand" @click="handleExpand">
            <span class="all all1">{{ $t('lang25') }}</span>
            <van-icon name="arrow-down" color="#999" size="14px" />
          </div>
        </div>
        <div class="goods_list" v-for="(item, index) in indexinfo.notice_list" :key="index" @click="navigatorToPage('GoodsDetail', item.id)">
          <van-image class="goods_list_img" radius="10" :src="item.img_url" />
          <div class="right">
            <span>{{ item.title }}</span>
            <div class="cen">
              <span class="money">10000</span>
              <div class="yel">
                <van-count-down class="count" :time="time" :format="`${$t('lang8')} DD ${$t('lang9')} HH ${$t('lang10')} mm ${$t('lang11')} ss ${$t('lang12')}`" />
              </div>
            </div>
            <div class="flex jsb flex_end">
              <div>
                <span class="time_text">{{ $t('lang6') }} 1000000USDT</span>
                <div class="progress">
                  <van-progress percentage="12" class="pro" color="#29b286" track-color="#9DDAC6" stroke-width="10" :show-pivot="false"> </van-progress>
                  <span class="p_text">{{ $t('lang26') }}12%</span>
                </div>
              </div>
              <div class="buy">
                <van-button class="buy_btn" type="primary">{{ $t('lang27') }}</van-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="pd goods_box">
        <div class="title">
          <div class="flex">
            <span>{{ $t('lang30') }}</span>
          </div>
          <div class="" v-show="isExpand" @click="handleExpand">
            <span class="all">{{ $t('lang24') }}</span>
            <van-icon name="arrow-up" color="#29b286" size="14px" />
          </div>
          <div class="" v-show="!isExpand" @click="handleExpand">
            <span class="all all1">{{ $t('lang25') }}</span>
            <van-icon name="arrow-down" color="#999" size="14px" />
          </div>
        </div>
        <div class="goods_list" v-for="(item, index) in indexinfo.notice_list" :key="index" @click="navigatorToPage('GoodsDetail', item.id)">
          <van-image class="goods_list_img" radius="10" :src="item.img_url" />
          <div class="right">
            <span>{{ item.title }}</span>
            <div class="cen">
              <span class="money">10000</span>
              <div class="yel">
                <van-count-down class="count" :time="time" :format="`${$t('lang8')} DD ${$t('lang9')} HH ${$t('lang10')} mm ${$t('lang11')} ss ${$t('lang12')}`" />
              </div>
            </div>
            <div class="flex jsb flex_end">
              <div>
                <span class="time_text">{{ $t('lang6') }} 1000000USDT</span>
                <div class="progress">
                  <van-progress percentage="12" class="pro" color="#29b286" track-color="#9DDAC6" stroke-width="10" :show-pivot="false"> </van-progress>
                  <span class="p_text">{{ $t('lang26') }}12%</span>
                </div>
              </div>
              <div class="buy">
                <van-button class="buy_btn" type="primary">{{ $t('lang27') }}</van-button>
              </div>
            </div>
          </div>
        </div>
      </div> -->
    </div>
    <!-- <BottomNavigation></BottomNavigation> -->
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import { mapState } from 'vuex';
import { homeApi } from '@/api/index';
import BottomNavigation from '@/components/BottomNavigation.vue';
import { Notify } from 'vant';
import { dateFormat } from '@/utils/formatTool.js';
export default {
  data() {
    return {
      show: false, //弹窗状态
      address: '', //上级地址
      noticeText: '', //公告
      indexinfo: {
        system_name: '',
        system_logo: '',
        banner_list: [],
        notice_list: [],
      },
      inviteCode: undefined,
      userinfo: {
        power: undefined,
        token: undefined,
        usdt: undefined,
        team_poser: undefined,
      },
      bindShow: false,
      time: 30 * 60 * 60 * 1000,
      showLoading: true,
      key: '',

      isExpand: true,
      cascaderValue: '',
      goodsInfo: [],
      goodsInfoExt: [],
      typeList: [],
    };
  },
  created() {
    this.inviteCode = this.$route.query.inviteCode;
    if (this.inviteCode) {
      localStorage.setItem('inviteCode', this.inviteCode);
    }

    // this.getUserInfo();
  },
  mounted() {
    this.init();
  },
  methods: {
    //返回上一页
    back() {
      this.$router.back();
    },
    init() {
      this.getPopularList();
      this.getIndexBaseInfo();
    },
    dateFormatFn(date) {
      return dateFormat(new Date(date * 1000), 'yyyy-MM-dd');
    },

    changeBanner(index) {
      this.$refs.swipeRef.swipeTo(index, { immediate: false });
    },
    getUserInfo() {
      homeApi.getUserInfo({ address: this.account, inviteCode: this.inviteCode }).then(res => {
        if (res.code == 200) {
          localStorage.setItem('userinfo', JSON.stringify(res.data));
          localStorage.setItem('parentId', res.data.parent_id);
          this.userinfo = res.data;
          if (this.userinfo.parent_id == 0) {
            this.show = true;
          }
          // if (this.userinfo.parent_id == 0) {
          //   this.bindParent();
          // }
        } else {
        }
      });
    },
    navigatorTo(name) {
      this.$router.push({ name });
    },
    navigatorToPage(name, id, product_id) {
      this.$router.push({ name, query: { id: id, product_id: product_id } });
    },
    getIndexBaseInfo() {
      homeApi.getIndexBaseInfo().then(res => {
        if (res.code == 200) {
          this.showLoading = false;
          this.indexinfo = res.data;
        } else {
          this.showLoading = false;
        }
      });
    },
    getPopularList() {
      homeApi.getPopularList().then(res => {
        if (res.code == 200) {
          this.showLoading = false;
          this.goodsInfo = res.data;
          this.goodsInfoExt = JSON.parse(JSON.stringify(res.data));
          // this.goodsInfoExt.forEach((element, index) => {
          //   var idx = this.typeList.indexOf(element.type_id);

          //   // 收起
          //   this.typeList.splice(idx, 1);
          //   if (this.goodsInfo[index].product.length > 0) {
          //     let info = JSON.parse(JSON.stringify(this.goodsInfoExt[index]));

          //     if (info.product.length > 0) {
          //       info.product.length = 1;
          //     }

          //     this.$set(this.goodsInfo, index, info);
          //   }
          // });
          this.goodsInfoExt.forEach((element, index) => {
            var idx = this.typeList.indexOf(element.type_id);

            // 展开
            this.typeList.push(element.type_id);
            this.$set(this.goodsInfo, index, JSON.parse(JSON.stringify(this.goodsInfoExt[index])));
          });
        } else {
          this.showLoading = false;
        }
      });
    },
    finish() {
      this.getPopularList();
    },
    toLink(e) {
      window.location.href = e;
    },
    toAssets() {
      this.$router.push({ name: 'assets' });
    },
    toPage(type) {
      this.$router.push({ name: 'datainfo', query: { type } });
    },
    toTeam() {
      this.$router.push({ name: 'trade' });
    },
    onClose(e) {},
    onChange(e) {},
    handleExpand(type_id, index) {
      var idx = this.typeList.indexOf(type_id);

      if (idx != -1) {
        // 收起
        this.typeList.splice(idx, 1);
        if (this.goodsInfo[index].product.length > 0) {
          let info = JSON.parse(JSON.stringify(this.goodsInfoExt[index]));

          if (info.product.length > 0) {
            info.product.length = 1;
          }

          this.$set(this.goodsInfo, index, info);
        }
      } else {
        // 展开
        this.typeList.push(type_id);
        this.$set(this.goodsInfo, index, JSON.parse(JSON.stringify(this.goodsInfoExt[index])));
      }
    },
  },
  computed: {
    ...mapState(['account']),
  },
  watch: {
    account(e) {
      // this.init();
      // this.bind();
    },
  },
  components: {
    Header,
    BottomNavigation,
  },
};
</script>

<style lang="less" scoped>
.head {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(#000, 0.8);
  letter-spacing: 1.5px;
  font-weight: 550;
  background: #fff;
  padding: 14px 0;
  z-index: 99;
  .arrow_img {
    position: absolute;
    left: 20px;
    width: 10px;
    height: 16px;
    // transform: translate(0, -50%);
  }
}
.home_page {
  padding: 50px 0 100px;
  min-height: 100vh;

  .pd {
    padding: 14px;
    // background-color: #fff;
  }
  .top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .cha {
      width: 100px;
    }

    .input {
      width: calc(100% - 110px);
      border: 1px solid #29b286;
      border-radius: 20px;
    }
    ::v-deep .van-field__control {
      padding: 6px 12px;
    }
    ::v-deep .van-icon-search {
      font-size: 20px;
      color: #29b286;
      font-weight: bold;
      margin-right: 10px;
    }
  }
  .notice {
    font-size: 13px;
    margin: 8px 0;
    .notice-ico {
      padding: 0 8px;
      border-radius: 20px;
      margin-right: 10px;
      background-color: #e8e8e8;
    }
  }
  ::v-deep .van-notice-bar {
    padding: 0 !important;
  }
  .banner {
    height: 160px;
    color: #fff;
    font-size: 22px;
    border-radius: 12px;
    .my-swipe {
      width: 100%;
      height: 100%;
      border-radius: 12px;
    }
  }

  .jsb {
    justify-content: space-between;
  }

  .goods_box {
    // margin: 14px;
    border-radius: 14px;
    .good_icon {
      width: 16px;
      height: 16px;
      margin-right: 5px;
    }
  }
  .title {
    color: #000;
    font-size: 15px;
    font-weight: 600;
    // font-style: italic;
    padding: 0 0 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .flex {
      max-width: 80%;
    }
    .all {
      font-size: 12px;
      font-weight: normal;
      font-style: normal;
      color: rgba(#29b286, 1);
    }
    .all1 {
      color: rgba(#999, 1);
    }
  }

  .goods_list {
    display: flex;
    // align-items: center;
    // justify-content: space-between;
    color: #000;
    padding: 14px;
    border-radius: 10px;
    // box-shadow: 0 4px 16px 0 rgba(53, 73, 93, 0.15);
    margin-bottom: 16px;
    // box-shadow: 4px 4px 15px 0px rgba(180, 212, 212, 0.29);
    background-color: #fff;
    // background-image: linear-gradient(90deg, rgba(217, 239, 239, 0.3) 0, rgba(217, 239, 239, 0.3) 0, rgba(225, 240, 242, 0.3) 100%, rgba(225, 240, 242, 0.3) 100%);
    &_img {
      width: 90px;
      height: 90px;
      border-radius: 10px;
      margin-right: 10px;
    }

    .right {
      width: calc(100% - 100px);
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      font-size: 13px;
      box-sizing: border-box;
      padding: 6px 0;

      .time_text {
        color: #7f7f7f;
        font-weight: normal;
        font-size: 10px;
        text-decoration: line-through;
      }
      .cen {
        color: red;
        // font-weight: 550;
        display: flex;
        align-items: center;
        // padding: 5px 0;
        font-size: 12px;
      }
      .money {
        font-size: 15px;
      }
      .ssm {
        font-size: 10px;
        font-weight: normal;
      }
      .mon_t {
        color: #000;
        font-weight: normal;
      }
      .yel {
        background-color: #f9f6e5;
        font-weight: normal;
        margin-left: 8px;
        padding: 0px 8px;
        border-radius: 16px;
        white-space: nowrap;
        .count {
          color: #f7c35d;
          font-size: 9px;
        }
      }
      .green {
        width: fit-content;
        color: #29b286;
        background-color: #ddf2e7;
        font-size: 10px;
        font-weight: normal;
        padding: 2px 6px;
        border-radius: 6px;
      }
      .t2 {
        text-decoration: none;
      }

      .progress {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 10px;
        margin-top: 11px;
        position: relative;

        .pro {
          width: 100%;
          overflow: hidden;
        }
        .p_text {
          font-size: 6px;
          position: absolute;
          color: #fff;
          right: 2px;
        }
      }
    }
    .buy {
      display: flex;
      align-items: flex-end;
      &_btn {
        height: 26px;
        line-height: 26px;
        font-size: 10px;
        background-color: #29b286;
        border: none;
        padding: 0 10px;
        white-space: nowrap;
        border-radius: 30px;
      }
    }
  }
}
.goods_list1 {
  flex-wrap: wrap;
  &_img {
    width: 100%;
    height: 70px;
    border-radius: 10px;
    margin-right: 10px;
  }
  .item {
    width: 45%;
    margin-bottom: 10px;
    .cen {
      padding-top: 4px;
      .mon_t {
        font-size: 11px;
        color: #7f7f7f;
      }
      .money::after {
        content: 'CHA/年';
      }
    }
  }
}
.bind_box {
  color: #000;
  padding: 20px 20px 30px;
  .address_field {
    border-bottom: 1px solid #cccccc9d;
    padding: 10px 0;
    margin: 20px 10px 20px;
  }
  .bind_button {
    color: #fff;
    text-align: center;
    background: #7938cf;
    border-radius: 20px;
    padding: 10px 0;
  }
}
.flex {
  display: flex;
  align-items: center;
}
.flex_end {
  align-items: flex-end;
}
::v-deep .van-cascader__option {
  color: #000;
}
.nomore {
  color: #aaa;
  text-align: center;
  font-size: 12px;
  padding: 20px 0;
}
.ellipsis {
  overflow: hidden; /* 确保超出容器的文本被裁剪 */
  white-space: nowrap; /* 确保文本在一行内显示 */
  text-overflow: ellipsis; /* 使用省略号表示文本超出 */
}
</style>